import request from '@/api/request'

export default {
  async getSizes () {
    return (await request.get(`module/action/marketplace/sicredi/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/sicredi/category/retrieve`)).data
  },
  async getCategoryAttributes (categoryId) {
    return (await request.get(`module/action/marketplace/sicredi/category/attributes/` + categoryId)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/sicredi/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/sicredi/index.js